var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 350,
    viewBox: "0 0 236 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_1914)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 200,
    height: 200,
    rx: 32,
    fill: "#F6F7FB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22_1914",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 200,
    height: 200
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 200,
    height: 200,
    rx: 32,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22_1914)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -46,
    width: 328,
    height: 328,
    fill: "url(#pattern0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4C0 1.79086 1.79086 0 4 0H16.454C17.3078 0 18 0.692173 18 1.54601C18 2.90131 16.9013 4 15.546 4H8C5.79086 4 4 5.79086 4 8V16C4 17.1046 3.10457 18 2 18C0.895431 18 0 17.1046 0 16V4Z",
    fill: "#3D1273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 4C236 1.79086 234.209 0 232 0H219.546C218.692 0 218 0.692173 218 1.54601C218 2.90131 219.099 4 220.454 4H228C230.209 4 232 5.79086 232 8V16C232 17.1046 232.895 18 234 18C235.105 18 236 17.1046 236 16V4Z",
    fill: "#3D1273"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 232C0 234.209 1.79086 236 4 236H16.454C17.3078 236 18 235.308 18 234.454C18 233.099 16.9013 232 15.546 232H8C5.79086 232 4 230.209 4 228V220C4 218.895 3.10457 218 2 218C0.895431 218 0 218.895 0 220V232Z",
    fill: "#3D1273"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 232C236 234.209 234.209 236 232 236H219.546C218.692 236 218 235.308 218 234.454C218 233.099 219.099 232 220.454 232H228C230.209 232 232 230.209 232 228V220C232 218.895 232.895 218 234 218C235.105 218 236 218.895 236 220V232Z",
    fill: "#3D1273"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22_1914)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 121C0 118.791 1.79086 117 4 117H232C234.209 117 236 118.791 236 121C236 123.209 234.209 125 232 125H4.00001C1.79087 125 0 123.209 0 121Z",
    fill: "#3D1273"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_22_1914",
    transform: "scale(0.00333333)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22_1914",
    x: -10,
    y: 112,
    width: 256,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.431373 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22_1914"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22_1914",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_1914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 350,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_22_1914",
    width: 300,
    height: 300,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.77055082706dd1c7f4800716e9240f0b.svg";
export { ForwardRef as ReactComponent };